import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 20v-10l10 6v-12","key":"svg-0"}],["path",{"d":"M13 7l3 -3l3 3","key":"svg-1"}]]

/**
 * IconArrowZigZag
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctemlnLXphZyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNiAyMHYtMTBsMTAgNnYtMTIiIC8+CiAgPHBhdGggZD0iTTEzIDdsMyAtM2wzIDMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-zig-zag
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowZigZag = createReactComponent('outline', 'arrow-zig-zag', 'ArrowZigZag', __iconNode);

export default IconArrowZigZag;